<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import collect from 'collect.js'

export default {
    mixins: [HasLoadingState],
    props: [],

    data() {
        return {
            reviews: [],
            form: new SparkForm(),
        }
    },

    created() {
        this.loadingUntil(done => {
            axios.get('/spark/kiosk/reviews').then(response => {
                this.reviews = response.data.data
                done()
            })
        })
    },

    methods: {
        impersonateBrand(review) {
            location.href =
                '/spark/kiosk/users/impersonate/' +
                review.reviewer.owner_id +
                '?redirect=' +
                route('brand.job.show', [review.reviewable.jobable.id, review.reviewable.id])
        },

        impersonateInfluencer(review) {
            location.href =
                '/spark/kiosk/users/impersonate/' +
                review.reviewee.id +
                '?redirect=' +
                route('influencer.job.show', [review.reviewable.id])
        },

        publish(review) {
            this.pop(review, Spark.post('/spark/kiosk/reviews/' + review.id, this.form))
        },

        reject(review) {
            this.pop(review, Spark.delete('/spark/kiosk/reviews/' + review.id, this.form))
        },

        pop(review, process) {
            process.then(() => {
                this.reviews = collect(this.reviews)
                    .reject(match => match.id === review.id)
                    .toArray()
            })
        },
    },
}
</script>
